// MUI
import { Box, Typography } from "@mui/material";

export function EnvironmentBadge() {
  const env = process.env.REACT_APP_ENVIRONMENT || "dev";
  if (env === "prod") {
    return null;
  }

  let bgColor: string;
  let label: string;

  if (env === "beta") {
    bgColor = "red";
    label = "Beta";
  } else {
    bgColor = "blue";
    label = "Dev";
  }

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        backgroundColor: bgColor,
        color: "white",
        borderRadius: 1,
        textAlign: "center",
        justifyContent: 'center',
        mt: 0.5,
        px: 1,
      }}
    >
      <Typography sx={{ fontWeight: "bold", fontSize: '15px' }}>
        {label}
      </Typography>
    </Box>
  );
}
